import {useEffect, useRef} from 'react'
import {useNavigate} from 'react-router-dom'
import {useAuth} from './core/Auth'

export function Logout() {
  const {logout} = useAuth()
  const navigate = useNavigate()
  const didLogout = useRef(false)
  useEffect(() => {
    if (didLogout.current) return
    didLogout.current = true
    logout()
    navigate('/auth/login', {replace: true})
  }, [logout, navigate])

  return null
}
